import axios from 'axios';
import * as actions from './actionsTypes';
import messages from '../../messages';
import WorkFlowServices from './workflow.services';
import toastr from 'toastr';

export const getWorkflows = filters => async dispatch => {
  try {
    dispatch({
      type: actions.LOADING_WORKFLOWS,
      payload: true
    });
    const resp = await WorkFlowServices.getWorkFlows(filters);
  
    dispatch({
      type: actions.GET_WORKFLOWS,
      payload: {
        workflows: resp.data.data,
        workflowLength: resp.data.count
      }
    });
    dispatch({
      type: actions.WORKFLOW_FORM_FAIL,
      payload: ''
    });
    dispatch({
      type: actions.WORKFLOW_FAIL,
      payload: ''
    });
  } catch (ex) {
    let message = '';
    if (axios.isAxiosError(ex)){
      if(ex.response?.data){
        message = ex.response.data.message;
      }else{
        message = ex.message === 'Network Error' ? messages.networkError : ex.message;  
      }
    }else{
      message = ex.message === 'Network Error' ? messages.networkError : ex.message; 
    }
    dispatch({
      type: actions.WORKFLOW_FAIL,
      payload: message
    });
  }finally{
    dispatch({
      type: actions.LOADING_WORKFLOWS,
      payload: false
    });
  }
}

export const getWorkflow = id => async dispatch => {
  try {
    dispatch({
      type: actions.LOADING_WORKFLOW,
      payload: true
    });
    const resp = await WorkFlowServices.getWorkFlow(id);
    dispatch({
      type: actions.GET_WORKFLOW,
      payload: resp.data
    });
  } catch (ex) {
    let message = '';
    if (axios.isAxiosError(ex)){
      if(ex.response?.status){
        switch (ex.response?.status) {
          case 404:
            message = messages.notFound;
            break;
          case 500:
            message = `${messages.errorMessage} ${ex.message}`;
            break;
          default:
            break;
        }
      }else{
        message = ex.message === 'Network Error' ? messages.networkError : ex.message;  
      }
      // if(ex.response?.data){
      //   message = ex.response.data.message;
      // }
    }else{
      message = ex.message === 'Network Error' ? messages.networkError : ex.message; 
    }
    dispatch({
      type: actions.WORKFLOW_FAIL,
      payload: message
    });
  }finally{
    dispatch({
      type: actions.LOADING_WORKFLOW,
      payload: false
    });
  }
}

const handleFormErrors = errors => {
  let message = null;
  const { nombre, descripcion, fecha_inicio, fecha_fin, estado, creador } = errors;
  if(nombre){
    message = nombre;
  }
  if(descripcion){
    if(typeof message === 'object' && message !== null){
      message = [...message, descripcion];
    }else{
      message = descripcion
    }
  }
  if(fecha_inicio){
    if(typeof message === 'object' && message !== null){
      message = [...message, fecha_inicio];
    }else{
      message = fecha_inicio;
    }
  }
  if(fecha_fin){
    if(typeof message === 'object' && message !== null){
      message = [...message, fecha_fin];
    }else{
      message = fecha_fin;
    }
  }
  if(estado){
    if(typeof message === 'object' && message !== null){
      message = [...message, estado];
    }else{
      message = estado;
    }
  }
  if(creador){
    if(typeof message === 'object' && message !== null){
      message = [...message, creador];
    }else{
      message = creador;
    }
  }
  return message;
}

export const saveWorkflow = data => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_WORKFLOWS,
      payload: true
    });
    
    const resp = await WorkFlowServices.saveWorkflow(data);
    const { workflows, workflowLength } = getState().workflow;
    dispatch({
      type: actions.GET_WORKFLOWS,
      payload: {
        workflows: [...workflows, resp.data],
        workflowLength: workflowLength + 1
      }
    });
    dispatch({
      type: actions.WORKFLOW_FORM_FAIL,
      payload: null
    });
    toastr.success(messages.successMessage, '', {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)){
      if(ex.response?.status){
        switch (ex.response.status) {
          case 400:
            message = handleFormErrors(ex.response.data);
            break;
          case 500:
            message = messages.errorMessage + ex.response.statusText
            break;
          default:
            message = ex.response.data;
            break;
        }
      }else{
        message = ex.message === 'Network Error' ? messages.networkError : ex.message;  
      }
    }else{
      message = ex.message === 'Network Error' ? messages.networkError : ex.message; 
    }
    dispatch({
      type: actions.WORKFLOW_FORM_FAIL,
      payload: message
    });
  }finally{
    dispatch({
      type: actions.SAVE_LOADING_WORKFLOWS,
      payload: false
    });
  }
}

export const editWorkflow = (data, index, id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_WORKFLOWS,
      payload: true
    });
    const resp = await WorkFlowServices.editWorkFlow(id, data);
    const { workflows, workflowLength } = getState().workflow;
    workflows[index] = resp.data;
    dispatch({
      type: actions.GET_WORKFLOWS,
      payload: {
        workflows: workflows,
        workflowLength: workflowLength
      }
    });
    dispatch({
      type: actions.WORKFLOW_FORM_FAIL,
      payload: null
    });
    toastr.success(messages.successMessage, '', {
      progressBar: true,
      rtl: true
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)){
      if(ex.response?.status){
        switch (ex.response.status) {
          case 400:
            message = handleFormErrors(ex.response.data);
            break;
          case 500:
            message = messages.errorMessage + ex.response.statusText
            break;
          default:
            message = ex.response.data;
            break;
        }
      }else{
        message = ex.message === 'Network Error' ? messages.networkError : ex.message;  
      }
    }else{
      message = ex.message === 'Network Error' ? messages.networkError : ex.message; 
    }
    dispatch({
      type: actions.WORKFLOW_FORM_FAIL,
      payload: message
    });
  }finally{
    dispatch({
      type: actions.SAVE_LOADING_WORKFLOWS,
      payload: false
    });
  }
}

export const deleteWorkflow = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_WORKFLOWS,
      payload: true
    });
    await WorkFlowServices.deleteWorkFlow(id);
    const { workflows, workflowLength } = getState().workflow;
    workflows.splice(index, 1);
    dispatch({
      type: actions.GET_WORKFLOWS,
      payload: {
        workflows: workflows,
        workflowLength: workflowLength - 1
      }
    });
    toastr.success(messages.successMessage, '', {
      progressBar: true,
      rtl: true
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)){
      if(ex.response?.status){
        switch (ex.response.status) {
          case 404:
            message = messages.notFound
            break;
          case 500:
            message = messages.errorMessage + ex.message;
            break;
          default:
            message = ex.response.data;
            break;
        }
      }else{
        message = ex.message === 'Network Error' ? messages.networkError : ex.message;  
      }
    }else{
      message = ex.message === 'Network Error' ? messages.networkError : ex.message; 
    }
    dispatch({
      type: actions.WORKFLOW_FAIL,
      payload: message
    });
  }finally{
    dispatch({
      type: actions.LOADING_WORKFLOWS,
      payload: false
    });
  }
}

export const copyWorkFlow = data => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_COPY_WORKFLOW,
      payload: true
    });
    const resp = await WorkFlowServices.copyWorkflow(data);
    const { workflows, workflowLength } = getState().workflow;
    dispatch({
      type: actions.GET_WORKFLOWS,
      payload: {
        workflows: [...workflows, resp.data.resultado],
        workflowLength: workflowLength + 1
      }
    });
    toastr.success(messages.successMessage, '', {
      progressBar: true,
      rtl: true
    });
  } catch (ex) {
    let message = '';
    if (axios.isAxiosError(ex)){
      if(ex.response?.status){
        switch (ex.response?.status) {
          case 404:
            message = messages.notFound;
            break;
          case 500:
            message = `${messages.errorMessage} ${ex.message}`;
            break;
          default:
            break;
        }
      }else{
        message = ex.message === 'Network Error' ? messages.networkError : ex.message;  
      }
      // if(ex.response?.data){
      //   message = ex.response.data.message;
      // }
    }else{
      message = ex.message === 'Network Error' ? messages.networkError : ex.message; 
    }
    dispatch({
      type: actions.WORKFLOW_FAIL,
      payload: message
    });
  }finally{
    dispatch({
      type: actions.LOADING_COPY_WORKFLOW,
      payload: false
    });
  }
}